import { Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { CSSProperties } from 'react';

type ButtonProps = {
  text: string;
  variant?: 'text' | 'outlined' | 'contained';
  style?: CSSProperties;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  color?: 'primary' | 'inherit' | 'secondary' | 'success' | 'error' | 'info';
  tooltip?: string;
  size?: 'small' | 'medium';
};

function ButtonComponent({
  text,
  variant,
  style,
  className,
  onClick = () => {},
  disabled,
  loading,
  color,
  tooltip,
  size,
}: ButtonProps) {
  return (
    <Tooltip title={tooltip}>
      <Button
        variant={variant || 'contained'}
        style={style}
        className={className}
        disabled={!!disabled}
        onClick={() => {
          if (loading) {
            return;
          }
          onClick();
        }}
        type='submit'
        color={color || 'primary'}
        size={size}
      >
        {/* Keep translated text inside an element React can safely replace. */}
        {loading ? <CircularProgress size={20} color='inherit' /> : <span>{text}</span>}
      </Button>
    </Tooltip>
  );
}

export default ButtonComponent;
